import { Box, Button, Divider, IconButton, Modal, ThemeProvider, Typography } from "@mui/material";
import { darkTheme, style, theme } from "../../../styles/styles";
import { useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { BookTable } from "./BookTable";
import AddBook from "./AddBook";
import Title from "../../Dashboard/Title";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

export const Book = () => {
    const [openModal, setOpenModal] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const navigate = useNavigate();

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false)

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleRefresh = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Title title="Quality Assurance" />
                <button
                    onClick={handleGoBack}
                    className="flex items-center gap-2 text-[#691e78] font-medium my-4"
                >
                    <IconButton sx={{ bgcolor: '#671e781a' }}>
                        <KeyboardBackspaceIcon sx={{ color: '#671E78' }} />
                    </IconButton>
                    Go Back
                </button>
                <Box sx={{ my: 5, display: "flex", justifyContent: "end" }}>
                    <Button
                        onClick={handleOpenModal}
                        variant="contained"
                        sx={{
                            textTransform: "initial",
                            fontFamily: "Gilroy-Bold",
                            height: "50px",
                            px: 7,
                            py: 0.5,
                        }}
                    >
                        Add Book
                    </Button>
                </Box>
                <div className="ring-1 ring-[#691e78] rounded-xl overflow-hidden">
                    <ThemeProvider theme={darkTheme}>
                        <Box sx={{ width: "100%" }}>
                            <Box>
                                <BookTable refreshKey={refreshKey} onRefresh={handleRefresh} />
                            </Box>
                        </Box>
                    </ThemeProvider>
                </div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Box align="right">
                            <IconButton onClick={handleCloseModal}>
                                <HighlightOffIcon />
                            </IconButton>
                        </Box>
                        <Box>
                            <Typography
                                variant="h4"
                                sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
                            >
                                Add Book
                            </Typography>
                            <Divider />
                        </Box>
                        <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
                            <AddBook
                                onSuccess={() => {
                                    handleRefresh();
                                    handleCloseModal();
                                }}
                            />
                        </Box>
                    </Box>
                </Modal>

            </Box >
        </ThemeProvider >
    );
};

export default Book;